
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      idTransacao: '',
      loadingBtn: false,
      dialogStatusPayment: false,
      loadingDataTableAgendamento: false,
      searchProdutosSdAgenda: [],
      sdagendastatus: false,
    }
  },

  computed: {
    ...mapGetters('payment-safe2pay', ['allStatusPayment']),
    ...mapGetters('sdagenda', ['sdagenda']),
    ...mapGetters('unidade', ['unidadeInformation']),
  },
  mounted() {
    this.verifysdagenda()
    this.sdagendastatus = this.sdagenda.status
  },

  methods: {
    ...mapActions('payment-safe2pay', ['statusPayment']),
    ...mapActions('sdagenda', ['schedulingStatus', 'verifysdagenda']),
    async searchOrder() {
      const validate = this.$refs.form.validate()
      if (!validate) {
        return false
      }
      this.loadingBtn = true
      const idTransacao = this.idTransacao
      const vendedor = this.unidadeInformation.cpfcnpj
      try {
        await this.statusPayment({ idTransacao, vendedor })
        if (this.allStatusPayment.codigo) {
          this.$toast.error('Nenhuma transação foi encontrada')
          this.dialogStatusPayment = false
          this.idTransacao = ''
        } else {
          this.dialogStatusPayment = true
          if (this.sdagenda.status !== false) {
            this.verifyScheduling()
          }
        }
        this.$refs.form.reset()
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingBtn = false
      }
    },
    async verifyScheduling() {
      this.loadingDataTableAgendamento = true
      try {
        const pedido = this.idTransacao
        const data = await this.schedulingStatus(pedido)
        this.searchProdutosSdAgenda = data
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingDataTableAgendamento = false
      }
    },
    sairDialog() {
      this.dialogStatusPayment = false
      this.searchProdutosSdAgenda = []
    },
  },
}
